import { createFileRoute } from '@tanstack/react-router'

import VouchersPage from '@/views/loyalty/vouchers/pages/vouchers.page'

export const Route = createFileRoute('/phong-nha/loyalty/vouchers')({
  component: VouchersPage,
})
